import React, { useState, useContext, useEffect } from 'react'
import {useTable,  useBlockLayout, useResizeColumns, usePagination, useSortBy, useFilters}  from 'react-table';
import { convertUTCDateStringToLocalDateWithFormatDDMMMYYHH24MISS, convertLocalDateToDisplayToday, convertLocalDateWithFormatDDMMMYY} from '../../vtUtil';
import { AppRelevantDataContext } from '../../AppContext';
import { FaSearch}  from 'react-icons/fa';
import { FaArrowDownLong, FaArrowUpLong } from 'react-icons/fa6';
import { FaQrcode } from 'react-icons/fa';
import {QrScanner} from '@yudiel/react-qr-scanner';
import axios from 'axios';
import { getAPIHostURL } from '../../ClientConfig';
import { Modal, ModalHeader, ModalBody} from 'reactstrap';
import { Pagination, Select } from 'antd';
import { CSV_COLUMN_SEPERATOR, CSV_LINE_SEPERATOR} from '../../VcConstants';
import { Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import '../CSS/blockUnblockDevices.css';

// Define a default UI for filtering
function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
  }) {
    const count = preFilteredRows.length
  
    return (
        <div style={{textOverflow: "ellipsis", whiteSpace: "nowrap", paddingLeft: "0.1rem", paddingRight: "0.3rem"}}>
            <FaSearch style={{marginRight:"0.3rem",color:"var(--secondaryColor)", fontSize:"1rem"}}/>
            <input
                 value={filterValue || ''}
                     onChange={e => {
                       setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
                     }}
                placeholder= "Search"
                style={{fontSize:"0.9rem",width: "85%", height:"100%", padding: "0.3rem", border:"1px solid rgba(0,0,0,.1)"}}
            />
        </div>
    );
}

// Create a default prop getter
const defaultPropGetter = () => ({})

const ReactTable = ({ columns, data, passedStateVariables, onFilteredDataChange}) => {

    // Allows overriding or adding additional filter types for columns to use
    const filterTypes = React.useMemo(
        () => ({
            text: (rows, id, filterValue) => {
            return rows.filter(row => {
                const rowValue = row.values[id]
                return rowValue !== undefined
                ? String(rowValue)
                    .toLowerCase()
                    .startsWith(String(filterValue).toLowerCase())
                : true
            })
            },
        }),
        []
    );

    // This is particularly useful for adding global column properties.
    const defaultColumn = React.useMemo(
        () => ({
            minWidth: 30,
            width: 450,
            Filter: DefaultColumnFilter,
        }),
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        prepareRow,
        rows,
        state: {pageIndex, pageSize},
        getRowProps = defaultPropGetter,
    } = useTable(
        {
            columns,
            data,
            defaultColumn,
            // autoResetPage: false,
            // set page size based on tables
            initialState: { pageSize: 10},
            filterTypes,
        },
        useBlockLayout,
        useResizeColumns,
        useFilters,
        useSortBy,
        usePagination,
    );

    useEffect(() => {
        if (onFilteredDataChange) {
            const filteredData = rows.map(row => row.original);
            onFilteredDataChange(filteredData);
        }
    }, [rows]);

    //uses the table header group props for the empty rows so resizing and flex layout still works
    const createEmptyRow = (NoData=false) => {
        return(
            <tr className = "tr"
                style= {{
                    textAlign:"left",
                    paddingLeft: "1rem",
                    textOverflow: "ellipsis", 
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    height: "2.6rem"
                }}
            >
                <td className = "td"
                >
                    {NoData == true?
                    <div><span>&nbsp;{!passedStateVariables[0] ? "No Data Found." : ""}</span></div>
                    :
                    <div><span>&nbsp;</span></div>
                    }
                </td>
            </tr>
                
        )
    };

    //creating empty padding cells
    const getEmptyRow = () => {
        let emptyRows = [];

        if(page.length%pageSize !== 0 && !canNextPage){
            for (let i = 0; i < (pageSize - page.length%pageSize); i++)
                emptyRows.push(createEmptyRow(false));

                // if(i == 0){
                //     emptyRows.push(createEmptyRow(true));
                // } else{
                // emptyRows.push(createEmptyRow(false));
                // }
        }

        if(data.length === 0 || page.length === 0){
            for (let i = 0; i < pageSize; i++){
                // emptyRows.push(createEmptyRow());
                if(i == 0){
                    emptyRows.push(createEmptyRow(true));
                } else{
                    emptyRows.push(createEmptyRow(false));
                }
            }
        }

        return emptyRows
    };

    return (
        <div>
            <div className='tableWrap'> 
                <table  {...getTableProps()}  style={{overflow:'auto'}} >
                    <thead>
                        {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()} className="trForHeader" >
                            {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps(column.getSortByToggleProps())} className="tdForHeader">
                                <div className='Header'>
                                    {column.render('Header') }
                                    <div className='fa' >
                                        {column.isSorted
                                        ? column.isSortedDesc
                                            ? <FaArrowDownLong />
                                            : <FaArrowUpLong />
                                        : ''}
                                    </div>
                                </div>
                                <div
                                    {...column.getResizerProps()}
                                    className={`resizer ${
                                        column.isResizing ? 'isResizing' : ''
                                    }`}
                                    // to stop other clicking events when resizing
                                    onClick={(event)=> event.stopPropagation()}
                                />
                            </th>
                            ))}
                        </tr>
                        ))}
                    </thead>

                    <thead >
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}  className="trforSearchField">
                                {headerGroup.headers.map(column => (
                                <th {...column.getHeaderProps()} className="tdForSearchField">
                                    <div>{column.canFilter ? column.render('Filter') : null}</div>
                                </th>
                                ))}
                            </tr>
                        ))}
                    </thead>

                    <tbody {...getTableBodyProps()} >
                        {page.map((row, i) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps(getRowProps(row))}
                                    className = "tr" 
                                    style={{
                                        cursor: '',
                                        background: '',
                                        color: 'black',
                                        alignItems: "center",
                                    }}  
                                >
                                    {row.cells.map(cell => {
                                    return <td {...cell.getCellProps(
                                        [
                                            {style: cell.column.style,},
                                        ]
                                    )} 
                                    className="td">{cell.render("Cell")}</td>;
                                    })}
                                </tr>
                            );
                        })}
                        {getEmptyRow()}
                    </tbody>
                </table>
            </div>

            <div className='w-100 d-flex justify-content-end antdPagination'>
                <div className='d-flex py-1 justify-content-end align-items-center'>
                    <Pagination showQuickJumper 
                        defaultCurrent={pageIndex + 1} 
                        total={pageOptions.length * 10}
                        // total={10 * 10} 
                        onChange={(page) => gotoPage(page - 1)} 
                        showSizeChanger={false}
                        current={pageIndex + 1} 
                    />

                    <Select
                        style={{ marginRight: "1rem", marginLeft: "1.5rem" }}
                        aria-label="rows per page"
                        className="paginationDropdown mySelector"
                        value={pageSize} // Assuming quickTrackParam is the state variable holding the selected value
                        onChange={e => setPageSize(Number(e))} 
                        options={[
                            {
                                label: "5 rows",
                                value: 5
                            },
                            {
                                label: "10 rows",
                                value: 10
                            },
                            {
                                label: "20 rows",
                                value: 20
                            },
                            {
                                label: "25 rows",
                                value: 25
                            },
                            {
                                label: "100 rows",
                                value: 100
                            }
                        ]} // Assuming options is the array of options for the Select component
                    />
                </div>
            </div>
        </div>
    );
};

function VcBlockOrUnblockDeviceData (props) {

    const context = useContext(AppRelevantDataContext);

    const filterCaseInsensitive = (rows, id, filterValue) => {

        if(id != "lastModifiedTime") {
            return rows.filter(row => {
                const rowValue = row.values[id]
                return rowValue !== undefined
                    ? String(rowValue.toString().toLowerCase()).includes(filterValue.toLowerCase())
                    : false
                });
        } else {
            return rows.filter(row => {
                let splittedStr = row.values[id].split(" ");
                const rowValue = row.values[id]

                if(String("Today".toString().toLowerCase()).includes(filterValue.toLowerCase()) &&
                            new Date(rowValue).getDate().toString().toLowerCase() == new Date().getDate().toString().toLowerCase() &&
                            new Date(rowValue).getMonth().toString().toLowerCase() == new Date().getMonth().toString().toLowerCase() &&
                            new Date(rowValue).getFullYear().toString().toLowerCase() == new Date().getFullYear().toString().toLowerCase()
                ) {
                    // Only for the case where the string entered in the filter box is present in cell
                    // then show all the rows which includes the input string in the final result (by returning true)
                    // It will return only those rows which contains a current date.                
                    return true;
                } else if(new Date(rowValue).getDate().toString().toLowerCase() == new Date().getDate().toString().toLowerCase() &&
                            new Date(rowValue).getMonth().toString().toLowerCase() == new Date().getMonth().toString().toLowerCase() &&
                            new Date(rowValue).getFullYear().toString().toLowerCase() == new Date().getFullYear().toString().toLowerCase() &&
                            String(splittedStr[1].toString().toLowerCase()).includes(filterValue.toString().toLowerCase()) ) {
                    // only for A "Today" case where Searching will always happens in a Time String.
                    return true;
                } else if(new Date(rowValue).getDate().toString().toLowerCase() == new Date().getDate().toString().toLowerCase() &&
                            new Date(rowValue).getMonth().toString().toLowerCase() == new Date().getMonth().toString().toLowerCase() &&
                            new Date(rowValue).getFullYear().toString().toLowerCase() == new Date().getFullYear().toString().toLowerCase()
                ) {
                    // It will return only those rows which should not contains a current date.
                    return false;
                }
                    else {
                    return String(rowValue.toString().toLowerCase()).includes(filterValue.toLowerCase())
                }
            });
        }
    };
                
    const [state, setState] = useState({
        EnteredDeviceID: '',
        manuallyAddedDeviceIDArrForDisplayBox: [],
        rplcDevcQRCodeFlag: false,
        invokedFrom: props.invokedFrom,
        showModalForSelectedStateProductionInventory: false,
        backdrop:'static',
        noDataFound: "",
        filteredDataForDownload: [],
        data : [],
        errors: { 
            others: '',
            invalidDevcID: '',
            invalidStateID: '',
        },

         columns: [
            {
                Header:() => <div className="AlertLogTableHeader">Device ID</div>,  
                accessor: 'deviceID',
                width: 200,
                filter: filterCaseInsensitive,
                style: ({
                    textAlign:"left",
                    paddingLeft: "1rem",
                    textOverflow: "ellipsis", 
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    height: "2.6rem"
                }),
            },
            {
                Header:() => <div className="AlertLogTableHeader">Device Name</div>,  
                accessor: 'deviceName', 
                width: 200,
                filter: filterCaseInsensitive,
                style: {
                    textAlign:"left",
                    paddingLeft: "1rem",
                    textOverflow: "ellipsis", 
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    height: "2.6rem"
                },
              
            },
            {
            
                Header:() => <div className="AlertLogTableHeader">Device Owner Email ID</div>,  
                accessor: 'deviceOwnerEmail',
                width: 250,
                filter: filterCaseInsensitive,
                style: {
                    textAlign:"left",
                    paddingLeft: "1rem",
                    textOverflow: "ellipsis", 
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    height: "2.6rem"
                },
                
            },
            {
            
                Header:() => <div className="AlertLogTableHeader">Organization Name</div>,  
                accessor: 'orgName',
                width: 250,
                filter: filterCaseInsensitive,
                style: {
                    textAlign:"left",
                    paddingLeft: "1rem",
                    textOverflow: "ellipsis", 
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    height: "2.6rem"
                },
                
            },
            {
            
                Header:() => <div className="AlertLogTableHeader">Block Reason</div>,  
                accessor: 'BlockReason',
                width: 200,
                filter: filterCaseInsensitive,
                style: {
                    textAlign:"left",
                    paddingLeft: "1rem",
                    textOverflow: "ellipsis", 
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    height: "2.6rem"
                },
                
            },
            {
                Header:() => <div className="AlertLogTableHeader">Subscription End Time</div>, 
                accessor: 'subscriptionEndTime',
                width: 290,
                filter: filterCaseInsensitive,
                sortType: (firstRow, secondRow, columnId) => {
                    const rowFirst = firstRow.original[columnId] == null ? "" : new Date(firstRow.original[columnId].toLowerCase()).getTime();
                    const rowSecond = secondRow.original[columnId] == null ? "" : new Date(secondRow.original[columnId].toLowerCase()).getTime();
                    return rowFirst > rowSecond ? 1 : -1
                },
                style: {
                    textAlign:"left",
                    paddingLeft: "1rem",
                    textOverflow: "ellipsis", 
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    height: "2.6rem"
                },
                
            }   
        ]
    });

    const menu = (
        <Menu
            onClick={({ key }) => {
            if(state.data != null && state.data.length > 0 ){
                    if (key === 'filtered') {
                        DownloadCsv(state.filteredDataForDownload);
                    } else if (key === 'all') {
                        DownloadCsv(state.data);
                    }
                }
            }}

            items={
            state.filteredDataForDownload.length === state.data.length
                ? [
                    {
                        key: 'all',
                        label: 'Download All Data',
                    }
                ]
                : [
                    {
                        key: 'filtered',
                        label: 'Download Filtered Data',
                    },
                    {
                        key: 'all',
                        label: 'Download All Data',
                    }
                ]
        }
        />
    );
    
    useEffect (() => {
        let modifiedState = state;
        if(modifiedState.invokedFrom != props.invokedFrom) {
            modifiedState.EnteredDeviceID = "";
            modifiedState.manuallyAddedDeviceIDArrForDisplayBox = [];
            modifiedState.invokedFrom = "";
            modifiedState.errors.others = "";
            modifiedState.errors.invalidDevcID = "";
            modifiedState.errors.invalidStateID = "";
            modifiedState.invokedFrom = props.invokedFrom;
            setState(modifiedState);
            return;
        } else {
            return;
        }
    },[props.invokedFrom]);

    const handleKeyDown = (e) => { 
        if (e.key == 'Enter') {
            // This is just to prevent form submission on pressing "enter".
            e.preventDefault();
            return;
        }
    }

    const onEnterDeviceID = (e) => {
        const value = e.target.value.toUpperCase();

        setState(prev => ({
            ...prev,
            EnteredDeviceID: value,
            errors: {
                ...prev.errors, // assumes it's an object
                others: '',
                invalidDevcID: '',
                invalidStateID: ''
            }
        }));
    };

    const openQRCameraForBlockOrUnblockDeviceData = async () => {

        let result = await navigator.permissions.query({name:'camera'}).then(function(result) {
            // Will return ['granted', 'prompt', 'denied']
            return result;
        })

        if(result.state == "denied") {
            alert("Camera permission is blocked for SmartHHM. Please enable Camera permission in browser.");
            return;
        } 
        
        let modifiedState = state;

        modifiedState.rplcDevcQRCodeFlag = !modifiedState.rplcDevcQRCodeFlag;
        modifiedState.errors.others = "";
        modifiedState.errors.invalidDevcID = "";        
        modifiedState.errors.invalidStateID = "";
        setState({...modifiedState});
    }

    const onClickAddDeviceValidation = () => {
        let modifiedState = state;

        modifiedState.errors.invalidDevcID = "";
        modifiedState.errors.others = "";
        modifiedState.errors.invalidStateID = "";

        if(modifiedState.manuallyAddedDeviceIDArrForDisplayBox.indexOf(modifiedState.EnteredDeviceID) != -1)  {
            modifiedState.errors.invalidDevcID = 'Device ID already exist.';
            setState({...modifiedState});
            return;
        } else {
            if(modifiedState.EnteredDeviceID == null || modifiedState.EnteredDeviceID.length <= 0) {
                modifiedState.errors.invalidDevcID = 'Please Enter Valid Device ID.';
                setState({...modifiedState});
                return;
            } else { 
                getDeviceIDValidation();
            }
        }
    }

    const viewBlockedDevicesReport = () => {

        let modifiedState = state;
        modifiedState.showModalForSelectedStateProductionInventory = !modifiedState.showModalForSelectedStateProductionInventory;

        modifiedState.data = [];
        modifiedState.errors.others = "";
        modifiedState.errors.invalidDevcID = "";        
        modifiedState.errors.invalidStateID = "";

        const jsonBody = {
            invokedFrom: "all", 
        };

        axios.post(`${getAPIHostURL()}/wclient/blockDevicesReport`, jsonBody)
        .then(response => {
            
            if(response.data.code == 'SUCCESS') {    

                if(response.data.blockDevicesReport == null || response.data.blockDevicesReport.length <= 0) {
                    modifiedState.noDataFound = "No Product Data Found.";
                } else {
                    let blockDevicesDetailsArr = [];
                                            
                    // React table checks using referential integrity. So if you do not create a
                    // new array (but just add to the existing array), the change detection will not trigger.
                    // So create a brand new array from existing Customer Details data.
                    blockDevicesDetailsArr = [...modifiedState.data]

                    const blockDevicesReport = response.data.blockDevicesReport;
                
                    for(let i = 0; i < blockDevicesReport.length; i++) {
                        const blockDeviceDetails = blockDevicesReport[i];
                        // let convertedSubscriptionEndTime = convertUTCDateStringToLocalDateWithFormatDDMMMYYHH24MISS(blockDeviceDetails.SubscriptionEndDtTm);
                        let convertedSubscriptionEndTime = blockDeviceDetails.SubscriptionEndDtTm ?               convertUTCDateStringToLocalDateWithFormatDDMMMYYHH24MISS(blockDeviceDetails.SubscriptionEndDtTm)
                            : "-";

                        let singleBlockDeviceDetails = {
                            deviceID: blockDeviceDetails.DeviceID == null || blockDeviceDetails.DeviceID == "" ? "-" : blockDeviceDetails.DeviceID,
                            deviceName:  blockDeviceDetails.DeviceName == null || blockDeviceDetails.DeviceName == "" ? "-" : blockDeviceDetails.DeviceName,
                            deviceOwnerEmail:  blockDeviceDetails.DeviceOwnerEmail == null || blockDeviceDetails.DeviceOwnerEmail == "" ? "-" : blockDeviceDetails.DeviceOwnerEmail,
                            orgName: blockDeviceDetails.OrgName == null || blockDeviceDetails.OrgName == "" ? "-" : blockDeviceDetails.OrgName,
                            BlockReason: blockDeviceDetails.Reason == null || blockDeviceDetails.Reason == "" ? "-" : blockDeviceDetails.Reason,
                            subscriptionEndTime: convertedSubscriptionEndTime == null || convertedSubscriptionEndTime.length <= 0 ? "-" : convertedSubscriptionEndTime,
                        };
                        blockDevicesDetailsArr.push(singleBlockDeviceDetails);
                    } 

                    modifiedState.data = blockDevicesDetailsArr;
                    
                }
            } else {
                if(response.data.code == 'SQL_ERROR') {
                    // Tell the user that Server is experiencing errors
                    modifiedState.errors.others = 'Server experiencing issues.\nTry again later.';
                } else {
                    console.log('Should not reach here');
                    modifiedState.errors.others = 'Server experiencing issues.\nTry again later.';
                }
            }
            setState({...modifiedState});
        })
        .catch(error => {
            console.log(error);
            console.log("Network error:");
            if (axios.isCancel(error)) {
                console.log('Axios request cancelled beacuse of too many requests being sent to the Server.');
            } else {
                modifiedState.errors.others = 'Network issues.\nCheck your Internet and Try again later.';
                setState({...modifiedState});
            }
        })
    }


    const getDeviceIDValidation =  () => {
        let modifiedState = state;

        let jsonBody = {
            EnteredDeviceID: modifiedState.EnteredDeviceID,
            invokedFrom: modifiedState.invokedFrom
        }

        axios.post( `${getAPIHostURL()}/wclient/checkDeviceIdExistence`, jsonBody)
        .then(response => {
            if(response.data.code == 'SUCCESS') {    

                if(response.data.isDeviceIDExist == null) {
                    modifiedState.errors.others = "Invalid Device ID.";
                } else if(response.data.isDeviceIDExist == 0) {
                    modifiedState.errors.invalidDevcID = 'Invalid Device ID.';
                } else if (modifiedState.invokedFrom != null && modifiedState.invokedFrom.length > 0 && 
                        modifiedState.invokedFrom == "blockDeviceData" && (response.data.isStateIDValid == 0 || response.data.isStateIDValid == null))
                {
                    modifiedState.errors.invalidStateID = 'Entered Device ID is Blocked or the Device ID is Invalid state.';
                } else if (modifiedState.invokedFrom != null && modifiedState.invokedFrom.length > 0 && 
                        modifiedState.invokedFrom == "unblockDeviceData" && (response.data.isStateIDValid == 0 || response.data.isStateIDValid == null))
                {
                    modifiedState.errors.invalidStateID = 'Entered Device ID is Unblocked or the Device ID is Invalid state.';
                } else { 
                    // Just wanted to show last inserted DeviceID at the top of DisplayBox.
                    modifiedState.manuallyAddedDeviceIDArrForDisplayBox.unshift(modifiedState.EnteredDeviceID);
                    modifiedState.EnteredDeviceID = "";
            } 
                
            } else {
                if(response.data.code == 'SQL_ERROR' || response.data.code == 'REQ_PARAMS_MISSING') {
                    // Tell the user that Server is experiencing errors
                    modifiedState.errors.others = 'Server experiencing issues.\nTry again later.';
                } else {
                    console.log('Should not reach here');
                    modifiedState.errors.others = 'Server experiencing issues.\nTry again later.';
                }
            }
            setState({...modifiedState});
        })
        .catch( error => {
            console.log("Network error:");
            console.log(error);
            if (axios.isCancel(error)) {
                console.log('Axios request cancelled beacuse of too many requests being sent to the Server.');
            } else {
                // Tell the user that there are network issues
                modifiedState.errors.others = 'Network issues.\nCheck your Internet and Try again later.';
                setState({...modifiedState});
            }
        }); 
    }

    const handleScanResultOfBlockOrUnblockDeviceData = (data) => {
        if(data) {
            let modifiedState = state;
            modifiedState.EnteredDeviceID = data;
            modifiedState.EnteredDeviceID = modifiedState.EnteredDeviceID.toUpperCase();
            modifiedState.rplcDevcQRCodeFlag = false;
            modifiedState.errors.others = "";
            modifiedState.errors.invalidDevcID = "";        
            modifiedState.errors.invalidStateID = "";

            if((modifiedState.EnteredDeviceID == null || modifiedState.EnteredDeviceID.length <= 0)) {
                modifiedState.errors.others = "No QR code found. Please make sure the QR code is within the camera's frame and try again."
            } 
            setState({...modifiedState});
        }
    }

    const checkIfDisplayBoxisEmpty = () => {
        let modifiedState = state;

        // modifiedState.errors.invalidDevcID = "";
        // modifiedState.errors.others = "";
        // modifiedState.errors.invalidStateID = "";

        if((modifiedState.manuallyAddedDeviceIDArrForDisplayBox == null  || modifiedState.manuallyAddedDeviceIDArrForDisplayBox.length <= 0) 
            && (modifiedState.EnteredDeviceID.length <= 0 || modifiedState.EnteredDeviceID == null)){
            modifiedState.errors.invalidDevcID = 'Please Enter Valid Device ID.';
            setState({...modifiedState});
            return;
        } else if ((modifiedState.manuallyAddedDeviceIDArrForDisplayBox == null  || modifiedState.manuallyAddedDeviceIDArrForDisplayBox.length <= 0) 
            && (modifiedState.EnteredDeviceID != null || modifiedState.EnteredDeviceID > 0)) {
            modifiedState.errors.invalidDevcID = 'Please Add Entered Device ID into Display Box.';
            setState({...modifiedState});
            return;
        } else {
            blockOrUnblockDataForSelectedDevice();
        }
    }

    const blockOrUnblockDataForSelectedDevice = () => {
        let modifiedState = state;
        
        let jsonBody = { 
            manuallyAddedDeviceIDArrForDisplayBox: modifiedState.manuallyAddedDeviceIDArrForDisplayBox,
            invokedFrom: modifiedState.invokedFrom,
        }

        axios.post( `${getAPIHostURL()}/wclient/blockOrUnblockDataForSelectedDevice`, jsonBody)
        .then(response => {
            if(response.data.code == 'SUCCESS') {  
                // Show alert to user with success msg.
                if(modifiedState.invokedFrom != null && modifiedState.invokedFrom.length > 0 && modifiedState.invokedFrom == 'blockDeviceData'){
                    alert("Successfully Blocked Device Data for selected Device ID(s).");
                } else {
                    alert("Successfully Unblocked Device Data for selected Device ID(s).");
                }

                modifiedState.EnteredDeviceID = "";
                modifiedState.manuallyAddedDeviceIDArrForDisplayBox = [];
                // modifiedState.invokedFrom = "";
                modifiedState.errors.others = "";
                modifiedState.errors.invalidDevcID = "";
                modifiedState.errors.invalidStateID = "";

            }  else {
                if(response.data.code == 'SQL_ERROR' || response.data.code == 'REQ_PARAMS_MISSING') {
                    // Tell the user that Server is experiencing errors
                    modifiedState.errors.others = 'Server experiencing issues.\nTry again later.';
                } else {
                    console.log('Should not reach here');
                    modifiedState.errors.others = 'Server experiencing issues.\nTry again later.';
                }
            }
            setState({...modifiedState});
        })
        .catch( error => {
            console.log("Network error:");
            console.log(error);
            if (axios.isCancel(error)) {
                console.log('Axios request cancelled beacuse of too many requests being sent to the Server.');
            } else {
                // Tell the user that there are network issues
                modifiedState.errors.others = 'Network issues.\nCheck your Internet and Try again later.';
                setState({...modifiedState});
            }

        })
    }

    const toggleShowSelectedStateProductionInventory = () => {
        let modifiedState = state;
        modifiedState.showModalForSelectedStateProductionInventory = !modifiedState.showModalForSelectedStateProductionInventory;
        setState({...modifiedState});
    }

    // const onClickDownload = () => {
    //     let modifiedState = state;

    //     if(modifiedState.data.length > 0) {
    //         DownloadCsv(modifiedState.filteredDataForDownload);
    //     } 
    // }

    const DownloadCsv = (inCsvData) => {      
    
        let modifiedState = state;

        let arrColumnKeys = ["Device Name", "Device Owner Email ID", "Organization Name", "Block Reason", "Subscription End Time"];

        let strCsvHeaderLine = "Device ID";
        let arrCsvAllLines = []; // All data lines having a "CRLF" at the beginning
        let strSingleCsvDataLine = "";
        let strColumnName = "";
        modifiedState.csvData = [];

        // Create rest of the columns in the header
        let noOfParams = arrColumnKeys.length;
        for (let j=0; j<noOfParams; j++) {
            strColumnName = arrColumnKeys[j];
            strCsvHeaderLine += (CSV_COLUMN_SEPERATOR + strColumnName);
        }

        let receivedAllBlockDevicesReport = inCsvData;
        let receivedAllBlockDevicesReportLen = inCsvData.length;
        let allInstanceInfo = [];

        // First push the header CSV line
        arrCsvAllLines.push(strCsvHeaderLine);

        for(let i = 0; i < receivedAllBlockDevicesReportLen; i++) {

            let singleInstanceInfo = {
                deviceID: receivedAllBlockDevicesReport[i]["deviceID"],
                deviceName: receivedAllBlockDevicesReport[i]["deviceName"],
                deviceOwnerEmail: receivedAllBlockDevicesReport[i]["deviceOwnerEmail"],
                BlockReason: receivedAllBlockDevicesReport[i]["BlockReason"],
                orgName: receivedAllBlockDevicesReport[i]["orgName"],
                subscriptionEndTime: receivedAllBlockDevicesReport[i]["subscriptionEndTime"],
            }

            allInstanceInfo.push(singleInstanceInfo);

            strSingleCsvDataLine = CSV_LINE_SEPERATOR +
                ((receivedAllBlockDevicesReport[i]["deviceID"] == null) ? '' : receivedAllBlockDevicesReport[i]["deviceID"] ) +
                CSV_COLUMN_SEPERATOR +
                ( (receivedAllBlockDevicesReport[i]["deviceName"] == null) ? '' : receivedAllBlockDevicesReport[i]["deviceName"] ) +
                CSV_COLUMN_SEPERATOR +
                ( (receivedAllBlockDevicesReport[i]["deviceOwnerEmail"] == null) ? '' : receivedAllBlockDevicesReport[i]["deviceOwnerEmail"] ) +
                CSV_COLUMN_SEPERATOR +
                ( (receivedAllBlockDevicesReport[i]["BlockReason"] == null) ? '' : receivedAllBlockDevicesReport[i]["BlockReason"] ) +
                CSV_COLUMN_SEPERATOR +
                ( (receivedAllBlockDevicesReport[i]["orgName"] == null) ? '' : receivedAllBlockDevicesReport[i]["orgName"] ) +
                CSV_COLUMN_SEPERATOR +
                ((receivedAllBlockDevicesReport[i]["subscriptionEndTime"] == null) ? '' : receivedAllBlockDevicesReport[i]["subscriptionEndTime"] ) ;

            arrCsvAllLines.push(strSingleCsvDataLine);
        }

        modifiedState.csvData = allInstanceInfo;
        // Create CSV File and fill it
        let bFileCreationStatus = createAndFillCsvFile(arrCsvAllLines);

        alert(`Block Devices Report download has started. Check your Browser's status bar or Downloads Folder.`);
    }

    const createAndFillCsvFile = (inarrCsvAllLines) => {

        let retVal = true;

        let fileName = "";

        let currentDate = convertLocalDateWithFormatDDMMMYY(new Date());

        fileName = "BlockDevicesReport on Date " + currentDate.split(" ")[0]+ ".csv";

        let link = document.createElement('a');
        link.setAttribute('download', fileName);
        link.href = makeTextFile(inarrCsvAllLines);
        document.body.appendChild(link);

        // wait for the link to be added to the document
        window.requestAnimationFrame(function () {
            let event = new MouseEvent('click');
            link.dispatchEvent(event);
            document.body.removeChild(link);
        });

        // Return true to indicate that operation performed successfully (in future any failures in 
        // the previous calls can be checked to return false)
        retVal = true;
        return retVal;
    }

    const makeTextFile = (arrText) =>  {

        let data = new Blob(arrText, {type: 'text/plain'});
        let modifiedState = state;

        // If we are replacing a previously generated file we need to
        // manually revoke the object URL to avoid memory leaks.
        if (modifiedState.textFile !== null) {
            window.URL.revokeObjectURL(modifiedState.textFile);
        }

        modifiedState.textFile = window.URL.createObjectURL(data);

        // Return a URL you can use as an href
        return modifiedState.textFile;
    }

    const NoteAccordingToPageInvokedFrom = (e) => {
        let modifiedState = state;

        if(modifiedState.invokedFrom != null && modifiedState.invokedFrom.length > 0 && modifiedState.invokedFrom == "blockDeviceData") { 
            return(
                <div style={{border: "1px solid #a8cca8", textAlign:"left", borderRadius:"0.5rem", marginBottom:"1rem", paddingTop:"0.5rem"}} >
                    <div style={{fontSize:"0.8rem", fontWeight:"bold", marginLeft:"0.5rem"}}>Note:</div>
                    <div style={{fontSize:"0.8rem", marginLeft:"0.5rem", marginRight:"0.5rem"}}>
                        - You can Block Device Data by Entering the Respective Device ID(s) you want to block.
                        <br/>
                        - The Device ID(s) should be in 'Mapped to Owner' or 'Mapped as Replacement' State.
                        <br/>
                        - You can only Enter Device ID(s) which are Unblocked.
                        <br/>
                        - Devices Blocked Manually must be Unblocked Manually when required.
                        <br/>
                        - Rental Devices with Expired Subscriptions are Automatically Blocked and can only be Unblocked after Subscription Renewal.       
                    </div>
                </div>       
            );
        } else if (modifiedState.invokedFrom != null && modifiedState.invokedFrom.length > 0 && modifiedState.invokedFrom == "unblockDeviceData"){
            return(
                <div style={{border: "1px solid #a8cca8", textAlign:"left", borderRadius:"0.5rem", marginBottom:"1rem", paddingTop:"0.5rem"}} >
                    <div style={{fontSize:"0.8rem", fontWeight:"bold", marginLeft:"0.5rem"}}>Note:</div>
                    <div style={{fontSize:"0.8rem", marginLeft:"0.5rem", marginRight:"0.5rem"}}>
                        - You can Unblock Device Data by Entering the Respective Device ID(s) you want to unblock.
                        <br/>
                        - The Device ID(s) should be in 'Mapped to Owner' or 'Mapped as Replacement' State.
                        <br/>
                        - You can only Enter Device ID(s) which are Blocked. 
                        <br/>
                        - Devices Blocked Manually must be Unblocked Manually when required.
                        <br/>
                        - If a Rental Device Subscription is Expired, the Device will remain Blocked even after Unblocking. It will only be Unblocked once the Subscription is renewed.      
                    </div>
                </div>       
            );         
        } else {
            return(<div></div>);
        }
    }
    
    return (
        <div>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="container col-lg-7 col-lg-offset-3 col-md-8 col-md-offset-3">
                        <div className="modal-body p-4 box">
                            <div
                                className="headingForComponentsOfCrmPage responsiveHeader"
                                >
                                <div className="headerTitle">
                                    {state.invokedFrom == "blockDeviceData"
                                    ? "Block Device Data"
                                    : "Unblock Device Data"}
                                </div>

                                <button
                                    type="button"
                                    onClick={viewBlockedDevicesReport}
                                    className="headerBtn"
                                >
                                    Block Devices Report
                                </button>
                            </div>
                                {NoteAccordingToPageInvokedFrom()} 
                            <form>
                                <div>
                                    <label className="reg-form-label" 
                                        style={{width:"100%"}}
                                    > Scan or Enter Device ID:
                                    </label>
                                    <input style={{width:"100%"}}
                                        className="input-form"
                                        value= {state.EnteredDeviceID}
                                        onKeyDown={handleKeyDown}
                                        onChange = {onEnterDeviceID}
                                        required
                                    />
                                    <label onClick = {openQRCameraForBlockOrUnblockDeviceData} className = "qrcodeTextBtn">
                                        <FaQrcode className = "qrcodeTextBtnIcon"/>
                                    </label>
                                    <div>
                                        {(state.rplcDevcQRCodeFlag == true)
                                        ?
                                        // <div style={{display: "flex", justifyContent: "center", marginTop: "1rem"}}>
                                        //     <QrReader
                                        //         scanDelay={300}
                                        //         onResult={(result, error) => {
                                        //             if (!!result) {
                                        //                 this.handleScanResultOfBlockOrUnblockDeviceData(result?.text);
                                        //             }
                                        //         }}
                                        //         className = "QRCodeCamBoxForModalAndContainer"
                                        //     />
                                        // </div>
                                        <div style={{display: "flex", justifyContent: "center", width: "50%",
                                                    marginTop:"2rem", marginBottom: "2rem", display: "block", marginLeft: "auto",
                                                    marginRight: "auto"}}>                                                
                                            <QrScanner
                                                scanDelay={300}
                                                onResult={(result, error) => {
                                                    if (!!result) {
                                                        handleScanResultOfBlockOrUnblockDeviceData(result?.text);
                                                    }
                                                }}
                                                className = "QRCodeCamBoxForModalAndContainer"
                                            />
                                        </div>
                                        :
                                        <div/>
                                        }
                                    </div>
                                    <div style={{display:"flex", justifyContent: "center", flexDirection:"column",marginTop: "1rem"}}>
                                        <button type={"button"}
                                            style={{borderRadius: "5px", 
                                                    width:'30%', 
                                                    marginLeft:'35%',
                                                    marginRight:'35%',
                                                    marginTop:"0.5rem",
                                                    backgroundColor: "var(--primaryColor)", color:"white", fontWeigh: 900,
                                                    fontSize: "1.2rem", padding: "0.4rem"}}
                                            className="btn-lg"
                                            onClick={onClickAddDeviceValidation} 
                                        > ADD
                                        </button>
                                        <span style={{color:"red", fontSize:"0.8rem", marginTop: "1rem"}}>{(state.errors.invalidDevcID != null && state.errors.invalidDevcID.length > 0) && state.errors.invalidDevcID}</span>
                                        <span style={{color:"red", fontSize:"0.8rem"}}>{(state.errors.invalidStateID != null && state.errors.invalidStateID.length > 0) && state.errors.invalidStateID}</span> 
                                    </div>
                                </div>
                                <div className="inputgroupCustom" style={{marginTop:"1.2rem"}}>
                                    <label className="reg-form-label">
                                        Displaying Entered Device ID(s):
                                    </label>
                                    <select  className="input-form" size="5" style={{height:"5%"}}>
                                        {(state.manuallyAddedDeviceIDArrForDisplayBox).map((addedDevcID,index) => <option key={index} value={addedDevcID}>{addedDevcID}</option>)}
                                    </select>                                    
                                </div>  
                                <div className="form-group reg-form" style={{marginTop:"1.5rem"}}>
                                    <button onClick = {checkIfDisplayBoxisEmpty} type="button" className="btn-lg"
                                            style={{backgroundColor: "var(--primaryColor)", borderColor: "var(--primaryColor)", width: "100%", color: "white", fontWeigh: 900, fontSize: "1.2rem", padding: "0.4rem", borderRadius: "5px"}}>
                                        {state.invokedFrom == "blockDeviceData" ? "Block Data For Entered Device ID(s)" : <div>Unblock Data For Entered Device ID(s)</div>}
                                    </button>
                                    <span style={{color:"red", fontSize:"0.8rem"}}>{(state.errors.others != null && state.errors.others.length > 0) && state.errors.others}</span>
                                </div>
                            </form>
                            <Modal size="xl" isOpen={state.showModalForSelectedStateProductionInventory} toggle={toggleShowSelectedStateProductionInventory} backdrop={state.backdrop}>
                                <ModalHeader toggle={toggleShowSelectedStateProductionInventory}> 
                                                Block Devices Report
                                </ModalHeader>
                                <ModalBody>
                                  <div>
                                    <div className="ProdInfo" style={{ marginTop: "0rem", paddingBottom: "1rem" }}>
                                        <div style={{ flex: "3" }} />
                                            <Dropdown overlay={menu} trigger={['click']}>
                                            <button
                                                type="button"
                                                style={{
                                                    borderRadius: "5px",
                                                    backgroundColor: "var(--primaryColor)",
                                                    color: "white",
                                                    fontWeight: "400",
                                                    border: "none",
                                                    padding: "3px 10px",
                                                    cursor: "pointer",
                                                    fontSize: "15px"
                                                }}
                                                className="btn-sm"
                                            >
                                                Download 
                                                <DownOutlined style={{paddingLeft: "0.4rem", fontSize: '13px'}}/>
                                            </button>
                                            </Dropdown>
                                        </div>
                                    </div>
                                    <div className="border border-3 ReactTableStyle">
                                        <ReactTable 
                                            columns={state.columns} 
                                            data={state.data}
                                            // as React Table is outside the main function, state varaibles cant be accessed there 
                                            // so passing all the state variables on which react table is dependent through passedStateVariable
                                            passedStateVariables = {[state.noDataFound]}
                                            onFilteredDataChange={(data) => {
                                                setState(prev => ({
                                                    ...prev,
                                                    filteredDataForDownload: data
                                                }));
                                            }}
                                        />
                                    </div>
                                </ModalBody>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
    
}

export default VcBlockOrUnblockDeviceData;
